import Swiper, { Navigation, Pagination, Scrollbar } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function initializeSliderAwards(containerId) {
    const containerSlider = $(containerId);

    const swiperAwards = new Swiper(containerId + ' .swiper', {
        modules: [Navigation, Pagination, Scrollbar],

        slidesPerView: 1,
        spaceBetween: 80,

        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            640: {
                slidesPerView: 2,
                spaceBetween: 24,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 24,
            },
        },

        pagination: {
            el: containerId + ' .swiper-pagination',
            type: 'progressbar',
        },

        navigation: {
            prevEl: containerId + ' .btn-prev',
            nextEl: containerId + ' .btn-next',
        },
    });

    swiperAwards.on('slideChange', function () {
        containerSlider.find('.slider-progress .progress-fill').css('width', Math.min(this.progress * 100, 100) + '%');
    });
}

$(function () {
    $('.slider-awards').each(function () {
        initializeSliderAwards('#' + $(this).attr('id'));
    });
});
